/** Mirror of apps/back/src/api/core/Events.js — keep in sync when adding events. */
const Events = {
  INSTALL_APP: 'INSTALL_APP',
  UNINSTALL_APP: 'UNINSTALL_APP',
  EMPLOYEE_REGISTERED: 'EMPLOYEE_REGISTERED',
  OPEN_APP: 'OPEN_APP',
  OPEN_CHANNEL: 'OPEN_CHANNEL',
  MESSAGE_SENT: 'MESSAGE_SENT',
  // ChatFlow-internal only — not selectable / not HTTP-delivered
  RESTART_CONVERSATION: 'RESTART_CONVERSATION',
  OMMNIOSIGN_SIGNER_SENT: 'OMMNIOSIGN_SIGNER_SENT',
  OMMNIOSIGN_SIGNER_VIEWED: 'OMMNIOSIGN_SIGNER_VIEWED',
  OMMNIOSIGN_SIGNER_SIGNED: 'OMMNIOSIGN_SIGNER_SIGNED',
  OMMNIOSIGN_SIGNER_DECLINED: 'OMMNIOSIGN_SIGNER_DECLINED',
  OMMNIOSIGN_DOCUMENT_COMPLETED: 'OMMNIOSIGN_DOCUMENT_COMPLETED',
  OMMNIOSIGN_DOCUMENT_EXPIRED: 'OMMNIOSIGN_DOCUMENT_EXPIRED',
  OMMNIOSIGN_DOCUMENT_CANCELLED: 'OMMNIOSIGN_DOCUMENT_CANCELLED',
};

/** Forced server-side for ChatFlow Apps (picker hidden in AppDrawer). */
export const CHATFLOW_APP_SUBSCRIBED_EVENTS = [Events.OPEN_CHANNEL, Events.MESSAGE_SENT];

/** Selectable in AppDrawer. Excludes ChatFlow-internal-only events. */
export const APP_SUBSCRIBABLE_EVENTS = Object.values(Events).filter(
  event => event !== Events.RESTART_CONVERSATION,
);

export default APP_SUBSCRIBABLE_EVENTS;
